import AvenirNextLTPro_Bold from './assets/fonts/AvenirNextLTPro-Bold.woff2';
import AvenirNextLTPro_It from './assets/fonts/AvenirNextLTPro-It.woff2';
import AvenirNextLTPro_Regular from './assets/fonts/AvenirNextLTPro-Regular.woff2';
import AvenirNextLTPro_Thin from './assets/fonts/AvenirNextLTPro-Thin.woff2';


export const avenir = {
  fontFamily: 'Avenir',
  fontStyle: 'normal',
  fontDisplay: 'swap',
  fontWeight: 400,
  src: `
    local('Avenir'),
    local('Avenir-Regular'),
    url(${AvenirNextLTPro_Regular}) format('woff2')
  `,
};

export const avenirIt = {
    fontFamily: 'Avenir',
    fontStyle: 'italic',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `
      local('Avenir-It'),
      url(${AvenirNextLTPro_It}) format('woff2')
    `,
  };
  
export const avenirBold = {
    fontFamily: 'Avenir',
    fontStyle: 'bold',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `
      local('Avenir-Bold'),
      url(${AvenirNextLTPro_Bold}) format('woff2')
    `,
  };
  
export const avenirThin = {
    fontFamily: 'Avenir',
    fontStyle: 'thin',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `
      local('Avenir-Thin'),
      url(${AvenirNextLTPro_Thin}) format('woff2')
    `,
  };